import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=019bb2ba&scoped=true"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"
import style0 from "./Cancel.vue?vue&type=style&index=0&id=019bb2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bb2ba",
  null
  
)

export default component.exports